import React from 'react';
import { Controller } from 'react-hook-form';
import Input from '@/components/inputNewGMaps';

function InputController({
  className,
  inputName,
  inputId,
  control,
  label,
  info,
  rules,
  onChangeGmaps = null,
}) {
  return (
    <Controller
      name={inputId}
      control={control}
      rules={rules}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { error },
      }) => (
        <Input
          className={className}
          id={inputId}
          name={inputName}
          label={label}
          value={value}
          error={error?.message || ''}
          onChange={(event) => {
            onChange(event);
            if(event){
              const { streetNumber } = event;
              if(streetNumber && streetNumber.long_name){
                onChangeGmaps(streetNumber.long_name)
              }
            }
          }}
          onBlur={onBlur}
          info={info}
        />
      )}
    />
  );
}
export default InputController;
